// Persisted gate-device credentials. The Go API issues the api_token
// ONCE at pair-claim time, so losing it means starting over with a
// fresh pair code from the office. localStorage on a kiosk tablet is
// the right home — sessionStorage would log the device out on every
// browser restart, and a cookie would interact badly with the
// bearer-auth model.
//
// The shape mirrors the polish-#13 SDK DevicePairResponse.

import type { DevicePairResponse } from "@sms/sdk";

const KEY = "sms.gate.v1";

export type PersistedDevice = Pick<
  DevicePairResponse,
  "api_token" | "device_id" | "school_id" | "label"
> & { gate_id?: string };

export function load(): PersistedDevice | null {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PersistedDevice;
    if (!parsed.api_token || !parsed.device_id) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function save(d: PersistedDevice): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(KEY, JSON.stringify(d));
}

export function clear(): void {
  if (typeof localStorage === "undefined") return;
  localStorage.removeItem(KEY);
}
